import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { login } from '../features/UserSlice';
import { auth } from '../firebase';
import '../styles/Login.css';

function Login({user}) {

    // need to create state
    const [name, setName]=useState();
    const [email, setEmail]= useState('');
    const [password, setPassword] = useState('');
    const [profilePic, setProfilePic] = useState('');

    const dispatch = useDispatch();


    const register =() =>{
        // full name is rquired 
        if(!name){
        return alert("Please enter full name");
        }

        auth.createUserWithEmailAndPassword(email,password)
        .then((userAuth) => {
            userAuth.user.updateProfile({
                displayName:name,
                photoURL:profilePic
            })
            .then(()=>{
                // at this point need to dispatch user created in to redux store
                // dispatch login action
                dispatch(login({
                    email:userAuth.user.email,
                    uid: userAuth.user.uid,
                    displayName: name,
                    photoURL:profilePic
                }))
            })
        }).catch((error) => alert(error.message));
    };

    const loginToApp =(e)=>{
        e.preventDefault();
        auth.signInWithEmailAndPassword(email,password)
        .then((userAuth) =>{
            dispatch(login({
                email:userAuth.user.email,
                uid:userAuth.user.uid,
                displayName: userAuth.user.displayName,
                profileUrl: userAuth.user.photoURL
            }))
        }).catch(error => alert(error.message))
    };

    return (
        <div className="linkedin_login">
            <img src="https://news.hitb.org/sites/default/files/styles/large/public/field/image/500px-LinkedIn_Logo.svg__1.png" alt="logo not found"/>

            <form className="linkedin-login-form">
                <input type="text" value = {name} onChange={(e)=>setName(e.target.value)}
                 placeholder="Full name(required if you are registering)"/>
                <input type="text"  value={profilePic} onChange={(e)=>setProfilePic(e.target.value)}
                placeholder="Profile pic URL(Optional)"/>
                <input type="email" value={email} onChange={(e)=>setEmail(e.target.value)}
                 placeholder="Email"/>
                <input type="password" value={password} onChange={(e)=>setPassword(e.target.value)}
                placeholder="Pasword"/>

                <button type='submit' onClick={loginToApp}>sign in</button>
                <span>Not a member? <span className="linkedin-register-link" onClick={register}>Register Now</span></span>
            </form>

            <div>
                <p className="developed_by">Developed by Prakash Tiwari</p>
            </div>
        </div>
    );
}

export const MemoizedLogin = React.memo(Login);